<template>
  <div
    v-bind:class="[$parent.isBreakpoint('xs') ? 'pl-5 pr-5' : '', $parent.isBreakpoint('sm') ? 'pl-3 pr-3' : '', $parent.isBreakpointMin('md') ? 'pl-1 pr-1' : '']">
    <v-card color="black" class="rond white--text" v-bind:class="$parent.blueBorder"
      :hover="connected && !heatingInProgress && ready && mode != '3'"
      v-on="connected && !heatingInProgress && ready && mode != '3' ? { click: () => editDialog = true } : {}">
      <!-- Chauffe widget -->
      <v-responsive :aspect-ratio="1 / 1">
        <v-card-text>
          <div class="paco_typo" v-bind:class="temperatureSetpointClass">{{ temperatureSetpoint }}</div>







          <!-- VERSION À DROITE -->
          <!-- 
          <v-layout row wrap v-if="sensor && sensor != '?'">

            <v-flex xs6 sm5 offset-sm1>
              <div v-bind:class="$parent.isSmall ? 'mt-1 mb-1' : 'mt-2 mb-2'">
                <div class="main_value_container paco_typo" v-bind:class="$parent.fontSize">{{ temperature }}</div>
              </div>
            </v-flex>
            <v-flex xs6 sm5>
              <div v-bind:class="$parent.isSmall ? 'mt-1 mb-1' : 'mt-2 mb-2'">
                <v-icon color="#42c125" class="mr-1" small :small="$parent.isSmall"
                  :large="$parent.isLarge">fa-thermometer</v-icon>
                <span class="paco_typo green_paco" v-bind:class="$parent.fontSize">{{ sensor }}</span>
              </div>
            </v-flex>

          </v-layout>
          <div v-else v-bind:class="$parent.isSmall ? 'mt-1 mb-1' : 'mt-2 mb-2'">
            <div class="main_value_container paco_typo" v-bind:class="$parent.fontSize">{{ temperature }}</div>
          </div>
        -->


          <!-- VERSION DESSOUS -->
          <div v-if="displaySensor">

            <div v-bind:class="$parent.isSmall ? '' : 'mt-2 mb-2'">
              <div class="main_value_container paco_typo" v-bind:class="$parent.fontSize">{{ temperature }}</div>
            </div>
            <div v-bind:class="$parent.isSmall ? 'mt-1' : 'mt-2 mb-2'">
              <v-icon color="#42c125" class="mr-1" small :small="$parent.isSmall"
                :large="$parent.isLarge">fa-thermometer</v-icon>
              <span class="paco_typo green_paco" v-bind:class="$parent.isSmall ? 'font_size_15' : $parent.fontSize">{{
                sensor }}</span>
            </div>
          </div>

          <div v-else v-bind:class="$parent.isSmall ? 'mt-1 mb-1' : 'mt-2 mb-2'">
            <div class="main_value_container paco_typo" v-bind:class="$parent.fontSize">{{ temperature }}</div>
          </div>


          <!-- VERSION intégrée -->
          <!--
          <div v-if="sensor && sensor != '?'">
            <div v-bind:class="$parent.isSmall ? 'mt-1 mb-1' : 'mt-2 mb-2'">
              <div class="main_value_container paco_typo" v-bind:class="$parent.fontSize">{{ temperature }} <v-icon
                  color="white" class="ml-3 mr-1 mb-1" small :small="$parent.isSmall"
                  :large="$parent.isLarge">fa-thermometer</v-icon>
                {{ sensor }}
              </div>
            </div>
          </div>
          <div v-else v-bind:class="$parent.isSmall ? 'mt-1 mb-1' : 'mt-2 mb-2'">
            <div class="main_value_container paco_typo" v-bind:class="$parent.fontSize">{{ temperature }}</div>
          </div>
      
        -->


          <div v-bind:class="$parent.isSmall ? 'mt-2' : 'mt-5'">
            <v-icon color="white" :small="$parent.isSmall" :large="$parent.isLarge">fa-thermometer-half</v-icon>
          </div>

        </v-card-text>
      </v-responsive>
    </v-card>

    <v-btn v-if="!heatingInProgress"
      :disabled="!connected || !ready || auto == '1' || startStopLoading || !ready || mode == '3'" color="primary" block
      @click="startConfirmDialog = true" class="boutonRond mt-3">{{ $t('heat.start_heating') }}</v-btn>

    <v-btn v-else :disabled="!connected || !ready || auto == '1' || startStopLoading || mode == '3'" color="primary" block
      @click="stopConfirmDialog = true" class="boutonRond mt-3">{{ $t('heat.stop_heating') }}</v-btn>

    <v-dialog v-model="startConfirmDialog" persistent max-width="500" @keydown.esc="startConfirmDialog = false">
      <v-card>
        <v-card-title class="headline">{{ $t('heat.start_confirm_title') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" flat @click="startConfirmDialog = false">{{ $t('global.cancel') }}</v-btn>
          <v-btn color="red darken-1" flat @click="startConfirmDialog = false; startHeat()">{{
            $t('global.validate')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="stopConfirmDialog" persistent max-width="500" @keydown.esc="stopConfirmDialog = false">
      <v-card>
        <v-card-title class="headline">{{ $t('heat.stop_confirm_title') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color flat @click="stopConfirmDialog = false">{{ $t('global.cancel') }}</v-btn>
          <v-btn color="red darken-1" flat @click="stopConfirmDialog = false; stopHeat()">{{
            $t('global.validate')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogue d'édition -->
    <v-dialog v-model="editDialog" persistent max-width="320px" @keydown.esc="cancel()">
      <v-card>
        <v-alert v-model="alert" dismissible type="error">{{ alertMessage }}</v-alert>
        <v-card-text v-if="!loading">
          <v-select :items="temperatureList" v-model="temperatureSetpointEdit" menu-props="auto"></v-select>
        </v-card-text>
        <v-card-text v-else class="text-xs-center">
          <v-progress-circular color="primary" indeterminate></v-progress-circular>
        </v-card-text>
        <v-card-actions>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-btn color="black" flat large block @click="cancel()" :disabled="loading">{{
                $t('global.cancel')
              }}</v-btn>
            </v-flex>
            <v-flex xs12 sm6>
              <v-btn color="green darken-1" flat large block @click="save()"
                :disabled="loading || this.temperatureSetpointEdit == this.temperatureSetpoint">{{
                  $t('global.save')
                }}</v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const TEMPERATURE_MAX = 120;

const TEMPERATURE_DESHYDRAT_MIN = 40;
const TEMPERATURE_DESHYDRAT_MAX = 65;
export default {
  data: () => ({
    editDialog: false,
    startConfirmDialog: false,
    stopConfirmDialog: false,
    alert: false,
    alertMessage: null,
    loading: false,
    startStopLoading: false,
    temperatureSetpointEdit: null
  }),
  computed: {
    connected() {
      return this.$store.state.connected;
    },
    ovenData() {
      return this.$store.state.ovenData;
    },
    working() {
      return this.ovenData.working;
    },
    // chauffe en cours (boolean)
    heatingInProgress() {
      if (this.working == "1") {
        return true;
      }
      return false;
    },
    temperature() {
      return this.ovenData.temperature;
    },
    sensor() {
      return this.ovenData.sensor;
    },
    displaySensor() {
      return this.sensor && this.sensor != '?' && this.sensor != '0' && this.sensor != '-1'
    },
    total() {
      return this.ovenData.total;
    },
    auto() {
      return this.ovenData.auto;
    },
    temperatureSetpoint() {
      return this.ovenData.temperatureSetpoint;
    },
    // mode
    mode() {
      return this.ovenData.mode;
    },
    // en veille ou non
    state() {
      return this.ovenData.state;
    },
    // veillle ou non (boolean)
    ready() {
      if (this.state == "1") {
        return true;
      } else {
        return false;
      }
    },
    // températures possibles
    temperatureList() {
      var tempList = [];
      if (this.mode == "2") {
        // mode déshydratation
        for (
          var i = TEMPERATURE_DESHYDRAT_MIN;
          i <= TEMPERATURE_DESHYDRAT_MAX;
          i++
        ) {
          tempList.push(i + "");
        }
      } else {
        // autres modes
        for (var i = 0; i <= TEMPERATURE_MAX; i++) {
          tempList.push(i + "");
        }
      }

      return tempList;
    },
    // class de conssigne de température
    temperatureSetpointClass() {
      var classObject = {};

      if (this.heatingInProgress) {
        if (Number(this.temperatureSetpoint) > Number(this.temperature)) {
          classObject["paco_rouge_pure--text"] = true;
        } else {
          classObject["orange--text"] = true;
        }
      } else {
        classObject["white--text"] = true;
      }

      classObject[this.$parent.fontSize] = true;
      //
      return classObject;
    }
    // est-ce que la chauffe est en cours ?
    /*
    heatingInProgress() {
      if (this.total > 0) {
        return true;
      }
      return false;
      // return this.heatingInProgress;
    } */
  },
  watch: {
    temperatureSetpoint() {
      this.temperatureSetpointEdit = this.temperatureSetpoint;
    },
    // mode
    mode() {
      if (this.mode == "2") {
        this.checkDehydratTemperature();
      }
    }
  },
  methods: {
    // creation de la liste des tempetatures possibles
    /*
    makeTemperatureListAvailable() {
      var tempList = [];
      for (var i = 0; i <= TEMPERATURE_MAX; i++) {
        tempList.push(i + "");
      }
      this.temperatureList = tempList;
    }, */
    // lance la chauffe
    startHeat() {
      this.startStopLoading = true;
      this.$store
        .dispatch("startHeat")
        .then(res => {
          // this.heatingInProgress = true;
          this.$store.commit("setWorking", "1");
        })
        .catch(err => { })
        .finally(() => {
          this.startStopLoading = false;
        });
    },
    // arrète de chauffe
    stopHeat() {
      this.startStopLoading = true;
      this.$store
        .dispatch("stopHeat")
        .then(() => {
          // this.heatingInProgress = false;
          this.$store.commit("setWorking", "0");
        })
        .catch(err => { console.log(err) })
        .finally(() => {
          this.startStopLoading = false;
        });
    },
    // annule
    cancel() {
      if (!this.loading) {
        this.editDialog = false;
        // reset la valeur d'édition
        this.temperatureSetpointEdit = this.temperatureSetpoint;
        // reset
        this.alert = false;
        this.alertMessage = null;
      }
    },
    // reset
    reset() {
      this.alert = false;
      this.alertMessage = null;
    },
    // enregistre
    save() {
      // sécu
      if (this.temperatureSetpointEdit == this.temperatureSetpoint) {
        return;
      }

      // loading
      this.loading = true;
      // requette
      this.$store
        .dispatch("pushTemperatureSetpoint", this.temperatureSetpointEdit)
        .then(() => {
          this.$store.commit(
            "setTemperatureSetpoint",
            this.temperatureSetpointEdit
          );
          this.loading = false;
          // ferme la dialog
          this.editDialog = false;
          //
          this.reset();
        })
        .catch(err => {
          console.error(err);
          this.alert = true;
          this.alertMessage = this.$t("global.connexionError");
          this.loading = false;
        });
    },
    // test la température de déshydratation  (40 <> 65)
    checkDehydratTemperature() {
      if (this.temperatureSetpoint < TEMPERATURE_DESHYDRAT_MIN) {
        this.temperatureSetpointEdit = TEMPERATURE_DESHYDRAT_MIN + "";
      } else if (this.temperatureSetpoint > TEMPERATURE_DESHYDRAT_MAX) {
        this.temperatureSetpointEdit = TEMPERATURE_DESHYDRAT_MAX + "";
      }
      this.save();
    }
  },
  mounted() {
    // this.makeTemperatureListAvailable();
    //
    if (this.temperatureSetpoint) {
      this.temperatureSetpointEdit = this.temperatureSetpoint;
    }
  }
};
</script>

<style>
.green_paco {
  color: #42c125
}
</style>
